// A plain, full-width entry point to a room's threads, shown under the chat header whenever the room
// has any. Replaces the cryptic "↳ 3" header chip: novices need a word, a count and a chevron.
import React from 'react';
import { View, Pressable, StyleSheet } from 'react-native';
import { Text } from './Text';
import { makeStyles, useTheme } from '../theme';

export function ThreadsStrip({ count, latestTs, unread = 0, onPress }: { count: number; latestTs?: number; unread?: number; onPress: () => void }) {
  const theme = useTheme(); const s = useStyles();
  if (count <= 0) return null;
  const when = latestTs ? fmtWhen(latestTs) : '';
  return (
    <Pressable onPress={onPress} style={({ pressed }) => [s.strip, pressed && { backgroundColor: theme.surface2 }]} accessibilityRole="button" accessibilityLabel={`Threads, ${count}${unread ? `, ${unread} new` : ''}`}>
      <View style={s.badge}><Text style={s.badgeText}>{count}</Text></View>
      <Text style={s.label}>{count === 1 ? 'Thread in this room' : 'Threads in this room'}</Text>
      {unread > 0 ? <Text style={[s.meta, s.new]} numberOfLines={1}>{unread} new</Text> : !!when && <Text style={s.meta} numberOfLines={1}>latest {when}</Text>}
      <Text style={s.chev}>›</Text>
    </Pressable>
  );
}

function fmtWhen(ts: number) {
  const d = new Date(ts); const now = new Date();
  return d.toDateString() === now.toDateString() ? d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : d.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

const useStyles = makeStyles((theme) => StyleSheet.create({
  strip: { flexDirection: 'row', alignItems: 'center', gap: 10, paddingHorizontal: 14, paddingVertical: 10, backgroundColor: theme.surface, borderBottomWidth: 1, borderBottomColor: theme.border },
  badge: { minWidth: 24, height: 24, paddingHorizontal: 7, borderRadius: 12, backgroundColor: theme.accent, alignItems: 'center', justifyContent: 'center' },
  badgeText: { color: theme.accentInk, fontSize: 12.5, fontWeight: '800' },
  label: { color: theme.ink, fontSize: 14.5, fontWeight: '600', flexShrink: 1 },
  meta: { color: theme.faint, fontSize: 12, fontFamily: theme.mono, flex: 1, textAlign: 'right' },
  new: { color: theme.accent, fontWeight: '800' },
  chev: { color: theme.faint, fontSize: 20, lineHeight: 22 },
}));
